import { gql } from "@apollo/client";

export const ASANA_LOOKUP_TASK = gql`
  mutation lookupTask($taskId: String!) {
    lookupTask(taskId: $taskId) {
      success
      error
      taskName
    }
  }
`;
export const ASANA_COPY_DOD_TASK = gql`
  mutation copyDodTask($dodTaskId: String!, $copyToTaskId: String!, $copyToTaskName: String!, $taskName: String!, $nameForCopiedTask: String!) {
    copyDodTask(dodTaskId: $dodTaskId, copyToTaskId: $copyToTaskId, copyToTaskName: $copyToTaskName, taskName: $taskName, nameForCopiedTask: $nameForCopiedTask) {
      success
      error
    }
  }
`;
